import React, { FC } from 'react';
import { create } from 'zustand';

export enum SettingsPages {
  Root = 0,
  TextLocale = 1,
  Speed = 2,
  MediumLocale = 3,
  Subtitles = 4,
  DarkMode = 5,
  SubtitleLocale = 6
}

interface Store {
  page: SettingsPages;
  open: boolean;
  /** Root menu item to focus after returning from a sub-page. */
  returnFocusTo: SettingsPages | null;
  setPage(page: SettingsPages): void;
  clearReturnFocus(): void;
  toggle(open?: boolean): void;
}

export const useSettingsStore = create<Store>((set, get) => ({
  page: SettingsPages.Root,
  open: false,
  returnFocusTo: null,
  setPage: page => {
    const { page: current } = get();

    // Remember which sub-page we left so Root can restore focus to that menu item.
    if (page === SettingsPages.Root && current !== SettingsPages.Root) {
      set({ page, returnFocusTo: current });
      return;
    }

    set({ page, returnFocusTo: null });
  },
  clearReturnFocus: () => set({ returnFocusTo: null }),
  toggle: open => {
    const next = open === undefined ? !get().open : open;
    if (!next) {
      set({
        open: false,
        page: SettingsPages.Root,
        returnFocusTo: null
      });
      return;
    }
    // Always land on Root when opening — callers like the language picker
    // may leave `page` on a sub-page while `open` stays false.
    set({ open: true, page: SettingsPages.Root, returnFocusTo: null });
  }
}));

export const SettingsProvider: FC<{ children: React.ReactNode }> = ({
  children
}) => <>{children}</>;
